//* ====================================/ GCP Specific Utils /====================================//

import { getObjectFromRedux } from 'infra/redux'
import { isValidAccountCredentials } from './utils'
import { getApplicationSignInURL } from 'features/applications'
import { getRsrcAccountRef } from 'features/resources'
import _ from 'lodash'
import store from 'infra/redux/store'

export const GCP_PROJECT_DISPLAY_TYPE = 'Project'
export const GCP_FOLDER_DISPLAY_TYPE = 'Folder'

export const GCP_CLOUD_ACCOUNT_ORG_PERMISSIONS = [
  'Browser',
  'Cloud SQL Admin',
  'Cloud SQL Client',
  'Organisation Role Administrator',
  'Security Admin',
  'Viewer',
  'Service Account Key Admin',
  'Service Account Admin',
  'Service Account Token Creator',
  'Kubernetes Engine Admin',
  'Deployment Manager Editor',
  'Cloud AlloyDB Admin',
  'BigQuery Data Owner',
  'IAM Recommender Admin'
]

export const GCP_CLOUD_ACCOUNT_FOLDER_PERMISSIONS = [
  'Browser',
  'Cloud SQL Admin',
  'Cloud SQL Client',
  'Security Admin',
  'Viewer',
  'Service Account Key Admin',
  'Service Account Admin',
  'Service Account Token Creator',
  'Kubernetes Engine Admin',
  'Deployment Manager Editor',
  'Cloud AlloyDB Admin',
  'BigQuery Data Owner',
  'IAM Recommender Admin'
]

export const GCP_CLOUD_ACCOUNT_PROJECT_PERMISSIONS = [
  'Browser',
  'Cloud SQL Admin',
  'Cloud SQL Client',
  'Role Administrator',
  'Security Admin',
  'Viewer',
  'Service Account Key Admin',
  'Service Account Admin',
  'Service Account Token Creator',
  'Kubernetes Engine Admin',
  'Deployment Manager Editor',
  'Cloud AlloyDB Admin',
  'BigQuery Data Owner',
  'IAM Recommender Admin'
]

export const checkGCPAccountCredentials = async (jsonCredentials) => {
  const payload = {
    ObjectMeta: {
      Name: 'gcp_check'
    },
    Spec: {
      GcpSpec: {
        GcpJsonCreds: jsonCredentials,
        CloudIDType: 'workforce-fed'
      },
      Discovery: true,
      AccountType: 'GCP'
    }
  }
  return await isValidAccountCredentials(payload)
}

export const GCP_API_REQUIRED_PERMS = [
  'Compute Engine API',
  'Cloud Monitoring API',
  'Cloud Logging API',
  'Identity and Access Management (IAM) API',
  'Kubernetes Engine API',
  'Cloud DNS API',
  'Cloud SQL Admin API',
  'Cloud Resource Manager API',
  'AlloyDB API',
  'BigQuery API',
  'Cloud Pub/Sub API',
  'Cloud Autoscaling API',
  'Cloud Functions API',
  'Cloud Bigtable Admin API',
  'IAM Service Account Credentials API'
]

/**
 * Check if the gcp resource is belonging to workforce federation account
 * @param {*} rsrc
 * @returns {boolean}
 */
export const checkGCPWorkforceRsrc = (rsrc) => {
  if (!rsrc || rsrc.ObjectMeta.Kind !== 'GcpResource') return false
  const account = getObjectFromRedux(getRsrcAccountRef(rsrc))
  return account?.Spec.GcpSpec.CloudIDType === 'workforce-fed'
}

export const getRsrcAccessLink = (rsrc) => {
  // check if the rsrc is wf rsrc
  return rsrc?.Status?.AccessLink
}

export const GCP_WORKFORCE_SETUP_URL_MAP = {
  test: 'https://ping-crestone.s3.us-west-2.amazonaws.com/test-one-pingone/workforce.sh',
  ort: 'https://ping-crestone.s3.us-west-2.amazonaws.com/ort-one-pingone/workforce.sh',
  prod: ''
}
